import React from "react";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";

export const logError = ({
  client,
  feature,
  user,
  message,
  request,
  severity,
}) => {
  let err = message;
  if (typeof message === "string") {
    err = new Error(message);
  }
  console.error(err, {
    metaData: {
      client,
      feature,
      request,
    },
    user,
    severity,
  });
};

// NOTE: replaces a bugsnag error boundary with a simpler logging error boundary.
// likely in limited use and will be removed in following cleanup tasks
const ErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  return (
    <ReactErrorBoundary fallback={null} onError={(err) => console.error(err)}>
      {children}
    </ReactErrorBoundary>
  );
};
export default ErrorBoundary;
